import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { Trans } from "@lingui/react/macro";
import { JSX } from "react";

export const Navigation = ({ actions }: { actions?: JSX.Element[] }) => {
  return (
    <header className="mobile-column fixed inset-x-0 top-0 z-10 flex justify-end bg-white p-5 pt-[calc(1.25rem+var(--safe-top))] dark:bg-zinc-950">
      <h1 className="flex-1 font-bold italic">
        <Trans>요기콕콕!</Trans>
        👉
      </h1>
      <nav className="flex gap-5">{actions}</nav>
    </header>
  );
};

interface StackedNavigationProps {
  actions?: JSX.Element[];
  onBack: () => void;
  title: string;
}

export const StackedNavigation = ({
  actions,
  onBack,
  title,
}: StackedNavigationProps) => {
  return (
    <header
      className="mobile-column fixed inset-x-0 top-0 z-10 grid bg-white p-5 pt-[calc(1.25rem+var(--safe-top))] dark:bg-zinc-950"
      style={{ gridTemplateColumns: "80px minmax(0, 1fr) 80px" }}
    >
      <button className="justify-self-start" onClick={onBack} type="button">
        <ChevronLeftIcon className="size-6" />
      </button>
      <h1 className="truncate text-center font-medium">{title}</h1>
      <div className="flex gap-5 justify-self-end">{actions}</div>
    </header>
  );
};
interface ActionButtonProps {
  disabled?: boolean;
  label: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}
interface ModalNavigationProps {
  left: ActionButtonProps;
  right: ActionButtonProps;
  title: string;
  titleId?: string;
}

export const ModalNavigation = ({
  left,
  right,
  title,
  titleId,
}: ModalNavigationProps) => {
  return (
    <header
      className="mobile-column fixed inset-x-0 top-0 z-10 grid bg-white p-5 pt-[calc(1.25rem+var(--safe-top))] dark:bg-zinc-950"
      style={{ gridTemplateColumns: "80px minmax(0, 1fr) 80px" }}
    >
      <button
        className="justify-self-start text-zinc-600 disabled:opacity-60 dark:text-zinc-400"
        disabled={left.disabled}
        onClick={left.onClick}
        type="button"
      >
        {left.label}
      </button>
      <h1 className="text-center font-medium wrap-anywhere" id={titleId}>
        {title}
      </h1>
      <button
        className="justify-self-end disabled:opacity-60"
        disabled={right.disabled}
        onClick={right.onClick}
        type="button"
      >
        {right.label}
      </button>
    </header>
  );
};

export const WebModalNavigation = ({
  left,
  right,
  title,
  titleId,
}: ModalNavigationProps) => {
  return (
    <header
      className="sticky top-0 z-10 grid items-center border-b border-zinc-100 bg-white/90 px-5 py-4 backdrop-blur-md dark:border-zinc-800/80 dark:bg-zinc-950/90"
      style={{ gridTemplateColumns: "80px minmax(0, 1fr) 80px" }}
    >
      <button
        className="justify-self-start text-sm text-zinc-500 transition-colors hover:text-zinc-800 disabled:opacity-40 dark:text-zinc-400 dark:hover:text-zinc-200"
        disabled={left.disabled}
        onClick={left.onClick}
        type="button"
      >
        {left.label}
      </button>
      <h1
        className="truncate text-center text-base font-semibold text-zinc-900 dark:text-zinc-100"
        id={titleId}
      >
        {title}
      </h1>
      <button
        className="justify-self-end text-sm font-semibold text-zinc-900 transition-colors hover:text-black disabled:opacity-40 dark:text-zinc-100 dark:hover:text-white"
        disabled={right.disabled}
        onClick={right.onClick}
        type="button"
      >
        {right.label}
      </button>
    </header>
  );
};
